// This is a shim for the process module used by axios
window.process = window.process || {};
window.process.env = window.process.env || {};
